import React, { useEffect, useRef } from "react";
import { icons } from "../../assets/icons";
import { Link, useLocation } from "react-router-dom";
import InputWithIcon from "../FormFields/InputWithIcon";
import { useState } from "react";
import { useAuth } from "../../contexts/AuthContext";
import Select from "react-dropdown-select";
import { FaCaretDown } from "react-icons/fa";
import { apiUrls } from "../../utils/api/apiUrls";
import useApi from "../../hooks/useApi";
import NotificationSidebar from "../NotificationSidebar/NotificationSidebar";
import { useClickAway } from "react-use";
import ProfilePic from "../../assets/images/profile1.png";
import { images } from "../../assets/images";

const DashboardHeader = ({
  showLogo,
  isSapActive = false,
  isVoucherDownload = false,
}) => {
  const location = useLocation();
  const dropdownRef = useRef();
  const { data = [], apiCall } = useApi();
  const [notificationCount, setNotificationCount] = useState(0);
  const { data: data1, apiCall: apiCall1 } = useApi();
  const { data: data2, apiCall: notificationCountApi } = useApi(false);
  const { data: storeName = [], apiCall: getStoreName } = useApi();
  const { data: financeName = [], apiCall: getFinanceName } = useApi();
  const [dropDownOpen, setDropDownOpen] = useState(false);
  const {
    logout,
    user,
    setSelectedStores,
    selectedStores,
    setStoreDropdownState,
    setSelectedManagersDropdownState,
    setSelectedManagers,
    selectedManagers,
    selectedFinanceUser,
    setSelectedFinanceUser,
  } = useAuth();
  const [notificationIsOpen, setNotificationIsOpen] = useState(false);
  const isStore = user?.userLabel === "Store";
  const isL1 = user?.userLabel === "L1";
  const isL2 = user?.userLabel === "L2";

  const isFinance = user?.userLabel === "Finance";
  const [storeFilters, setStoreFilters] = useState({
    finance: isFinance ? user?.username : "",
    rm: "all",
    am: "all",
  });
  const onClickClose = () => {
    setDropDownOpen(false);
  };

  useClickAway(dropdownRef, () => {
    setDropDownOpen(false);
  });

  const notificationApiCall = () => {
    notificationCountApi({
      url: `${apiUrls.dmsService.getNotificationCount}`,
      method: "get",
      onSuccess: (data) => {
        setNotificationCount(data);
      },
    });
  };

  useEffect(() => {
    let notificationCall = setInterval(() => {
      notificationApiCall();
    }, 300 * 1000);
    return () => {
      clearInterval(notificationCall);
    };
  }, []);

  const getAllStoreApi = (params) => {
    let url = ``;
    if (params?.finance) {
      url = `${apiUrls.dmsService.getAllStores}${params?.finance}/${params?.rm}/${params?.am}`;
    } else if (params?.rm && params?.am === "all") {
      url = `${apiUrls.dmsService.getAllStores}${params?.rm}`;
    } else if (params?.am) {
      url = `${apiUrls.dmsService.getAllStores}${params?.am}`;
    }

    if (!url) return;

    apiCall({
      url: url,
      method: "get",
      onSuccess: (data) => {
        setSelectedStores({ storeDetails: { storeCode: "All", name: "All" } });
        setStoreDropdownState(data);
        localStorage.setItem("storeList", JSON.stringify(data));
      },
    });
  };

  const getAllRegionalManagerApi = (financeId) => {
    getFinanceName({
      url: `${apiUrls.dmsService.getAllRegionalManager}/${financeId}`,
      method: "get",
      onSuccess: (data) => {
        setSelectedFinanceUser([{ username: "All", name: "All" }]);
        setStoreDropdownState(data);

        setStoreFilters({ ...storeFilters, rm: "all", am: "" });
        getAllManagersApi("all", isFinance ? financeId : "");
      },
      startLoading: false,
    });
  };

  const getAllManagersApi = (rm, finance = "") => {
    let url = `${apiUrls.dmsService.getAllAreaManager}${rm}`;
    if (finance !== "") {
      url = url + `/${finance}`;
    }
    apiCall1({
      url: url,
      method: "get",
      onSuccess: (data) => {
        setSelectedManagersDropdownState(data);
        if (data[0].username) {
          setSelectedManagers([{ username: "All", name: "All" }]);
          let params = {
            finance: finance,
            rm: rm,
            am: "all",
          };
          getAllStoreApi(params);
          setStoreFilters(params);
        }
      },
      startLoading: false,
    });
  };

  useEffect(() => {
    const { username = "", userLabel = "L1" } = user || {};

    if (user?.userLabel === "Finance") {
      setStoreFilters({
        finance: user?.username,
        rm: "",
        am: "",
      });
    }

    if (userLabel === "L1") {
      let params = {
        am: username,
      };
      getAllStoreApi(params);
    }

    if (userLabel === "L2") {
      setStoreFilters({
        finance: "",
        rm: user?.username,
        am: "all",
      });
      getAllManagersApi(username, isFinance ? username : "");
    }

    if (isFinance) {
      getAllRegionalManagerApi(username, username);
    }
  }, [user.username]);

  useEffect(() => {
    getStoreName({
      url: apiUrls.dmsService.getStoreName,
      method: "get",
    });
  }, []);

  const dropDownOptions = !isStore
    ? [
        { name: "My Account", icon: icons.accountIcon, link: "/myaccount" },
        { name: "Help Center", icon: icons.helpIcon2, link: "/helpcenter" },
        {
          name: "Change Password",
          icon: icons.signoutIcon,
          link: "/changepassword",
        },
        { name: "Sign Out", icon: icons.signoutIcon, onClick: () => logout() },
      ]
    : [
        { name: "My Account", icon: icons.accountIcon, link: "/myaccount" },
        { name: "Help Center", icon: icons.helpIcon2, link: "/helpcenter" },
        {
          name: "Raise A Request",
          icon: icons.raiseIcon,
          link: "/raisearequest",
        },
        {
          name: "Change Password",
          icon: icons.signoutIcon,
          link: "/changepassword",
        },
        { name: "Sign Out", icon: icons.signoutIcon, onClick: () => logout() },
      ];
  const renderLeft = () => {
    if (showLogo) {
      return (
        <div className="flex flex-col justify-center p-2 px-3">
          <img
            src={images.mainLogo}
            alt="keventers' logo"
            className="w-[180px] mt-5"
          />
        </div>
      );
    }

    if (["/helpcenter", "/assignedtome"].includes(location.pathname)) {
      return <div />;
    }

    if (location.pathname === "/myaccount") {
      <InputWithIcon
        placeholder="Search"
        containerClassName="!w-[48rem] !h-[5rem] !bg-[var(--whiteColor)] !px-[2rem] shadow-[0_0_6px_#00000029]"
        inputClassName="flex font-size-medium placeholder-[var(--lightGray)]"
        rightIcon={icons.searchIcon}
      />;
    }

    return (
      !isSapActive &&
      !isVoucherDownload && (
        <div className="flex">
          {isFinance && (
            <Select
              dropdownGap={-8}
              wrapperClassName="!w-[100%]"
              className="!border-[0px] !w-[18rem] dropdown"
              options={[{ username: "All", name: "All" }, ...financeName]}
              labelField="name"
              valueField="username"
              onChange={(val) => {
                let isAllSelect = val?.find((i) => i.username === "All");
                if (
                  isAllSelect?.username &&
                  isAllSelect?.username === "All" &&
                  user?.username
                ) {
                  // debugger

                  setStoreFilters({ ...storeFilters, rm: "all", am: "" });
                  getAllManagersApi("all", isFinance ? user?.username : "");
                } else {
                  setStoreFilters({
                    ...storeFilters,
                    rm: val[0]?.username,
                    am: "",
                  });
                  getAllManagersApi(
                    val[0]?.username || "",
                    isFinance ? user?.username : ""
                  );
                }

                setSelectedFinanceUser({ storeDetails: val[0] });
              }}
              contentRenderer={() => {
                return (
                  <div className="store-details-container">
                    <div className="font-size-extra-small font-family-medium text-[var(--lightGray2)]">
                      REGIONAL MANAGER
                    </div>
                    <div className="flex items-center justify-center gap-x-3 !w-[100%]">
                      <div className="store-name-text font-family-medium">
                        {selectedFinanceUser?.storeDetails?.username ||
                          selectedFinanceUser[0]?.username ||
                          "All"}
                      </div>

                      {isFinance && <FaCaretDown size={22} className="mt-3" />}
                    </div>
                  </div>
                );
              }}
              dropdownHandle={false}
            />
          )}
          {data1?.length && (
            <Select
              dropdownGap={-8}
              wrapperClassName="!w-[100%]"
              className="!border-[0px] !w-[18rem] dropdown"
              options={[{ username: "All", name: "All" }, ...data1]}
              labelField="name"
              valueField="username"
              onChange={(val) => {
                let isAllSelect = val?.find((i) => i.username === "All");
                if (
                  isAllSelect?.username &&
                  isAllSelect?.username === "All" &&
                  user?.username
                ) {
                  // debugger
                  let params = {
                    ...storeFilters,
                    am: "all",
                  };
                  getAllStoreApi(params);
                } else {
                  let params = {
                    ...storeFilters,
                    am: val[0]?.username,
                  };
                  getAllStoreApi(params);
                }
                setSelectedManagers({ storeDetails: val[0] });
              }}
              contentRenderer={() => {
                return (
                  <div className="store-details-container">
                    <div className="font-size-extra-small font-family-medium text-[var(--lightGray2)]">
                      AREA MANAGER
                    </div>
                    <div className="flex items-center justify-center gap-x-3 !w-[100%]">
                      <div className="store-name-text font-family-medium">
                        {selectedManagers?.storeDetails?.name ||
                          selectedManagers[0]?.username ||
                          "All"}
                      </div>

                      {(isL2 || isFinance) && (
                        <FaCaretDown size={22} className="mt-3" />
                      )}
                    </div>
                  </div>
                );
              }}
              dropdownHandle={false}
            />
          )}
          {data?.length ? (
            data?.length ? (
              <Select
                dropdownGap={-8}
                wrapperClassName="!w-[100%]"
                className="!border-[0px] !w-[24rem] dropdown"
                options={[
                  // { name: "Please select", storeCode: "" },
                  { storeCode: "All", name: "All" },
                  ...data?.map((item) => ({
                    name: `${item?.name} (${item?.storeCode})`,
                    storeCode: item?.storeCode,
                  })),
                ]}
                labelField="name"
                valueField="storeCode"
                onChange={(val) => {
                  setSelectedStores({ storeDetails: val[0] });
                }}
                contentRenderer={() => {
                  return (
                    <div className="store-details-container">
                      <div className="font-size-extra-small font-family-medium text-[var(--lightGray2)]">
                        STORE NAME
                      </div>
                      <div className="flex items-center justify-center gap-x-3 !w-[100%]">
                        <div className="store-name-text font-family-medium">
                          {selectedStores?.storeDetails?.storeCode ||
                            selectedStores[0]?.storeCode ||
                            "All"}
                        </div>

                        <FaCaretDown size={22} className="mt-3" />
                      </div>
                    </div>
                  );
                }}
                dropdownHandle={false}
                values={
                  selectedStores?.storeDetails?.storeCode
                    ? [selectedStores?.storeDetails]
                    : [selectedStores[0]]
                }
              />
            ) : null
          ) : storeName && isStore ? (
            <div className="store-details-container">
              <div className="font-size-extra-small font-family-medium text-[var(--lightGray2)]">
                {/* STORE NAME */}
              </div>
              <div className="flex items-center justify-center gap-x-3 !w-[100%]">
                <div className="store-name-text font-family-medium">
                  {storeName || "Kamla Nagar"}
                </div>
              </div>
            </div>
          ) : null}
        </div>
      )
    );
  };

  const closeNotificationSidebar = () => {
    setNotificationIsOpen(false);
  };

  const notificationCountCss = {
    position: "absolute",
    top: "9px",
    right: "6px",
    border: "none",
    background: "red",
    borderRadius: "16px",
    width: "16px",
    height: "16px",
    textAlign: "center",
  };

  return (
    <>
      <div
        className={`header-container ${
          isSapActive || isVoucherDownload ? "justify-end" : "justify-between"
        }`}
      >
        {renderLeft()}
        {/* {showLogo && (
          <div className='text-[2rem] text-center font-[600] font-["Fraunces"] self-center ml-12'>
            KICS - Keventers Internal Communication System
          </div>
        )} */}
        <div className="flex items-center gap-x-[1rem]">
          <div className="relative">
            <img
              src={icons.bellIcon}
              alt="Notification Bell Icon"
              className="w-[4rem] h-[4rem] mt-2 cursor-pointer"
              onClick={() => {
                notificationApiCall(); // to update call count status
                setNotificationIsOpen(true);
              }}
            />
            {notificationCount > 0 && (
              <div style={notificationCountCss}>
                <span className="text-white font-semibold text-sm">
                  {notificationCount || ""}
                </span>
              </div>
            )}
          </div>
          <div
            className={`px-5 relative min-w-[22.5rem] ${
              dropDownOpen ? "shadow-[0_0_6px_#00000029] bg-[#fff]" : ""
            }`}
            ref={dropdownRef}
          >
            <div
              className="flex gap-x-[1.2rem] cursor-pointer py-2 select-none"
              onClick={() => setDropDownOpen(!dropDownOpen)}
            >
              <img
                // src="https://picsum.photos/200/300"
                src={ProfilePic}
                className="user-image"
                alt="user"
              />

              <div className="cursor-pointer">
                <div className="flex items-center">
                  <div className="font-size-medium font-family-medium text-[var(--blackColor)] mr-4">
                    {user?.name}
                  </div>
                  <img
                    src={icons.arrowDown}
                    alt="arrow down"
                    className={`h-[0.9rem] w-[1.4rem] arrow ${
                      dropDownOpen ? "rotate" : ""
                    }`}
                  />
                </div>
                <div className="font-size-small text-[var(--lightGray)] leading-[1.4rem]">
                  {user?.userLabel}
                </div>
              </div>
            </div>
            <div
              className={`profile-dropdown min-h-[10rem] w-[100%] absolute z-50 bg-[var(--whiteColor)] left-0 font-size-small text-[var(--darkGray)] ${
                dropDownOpen ? "unhide-dropdown" : ""
              }`}
            >
              {dropDownOptions?.map((item) => {
                if (item?.link) {
                  return (
                    <div key={item.name}>
                      <Link
                        to={item.link}
                        className="flex items-center gap-x-4 cursor-pointer"
                        onClick={onClickClose}
                      >
                        <img src={item.icon} alt={item.name} />
                        <div>{item.name}</div>
                      </Link>
                    </div>
                  );
                } else {
                  return (
                    <div
                      key={item.name}
                      className="flex items-center gap-x-4 cursor-pointer"
                      onClick={item.onClick}
                    >
                      <img src={item.icon} alt={item.name} />
                      <div>{item.name}</div>
                    </div>
                  );
                }
              })}
            </div>
          </div>
        </div>
      </div>
      {notificationIsOpen && (
        <NotificationSidebar
          closeNotificationSidebar={closeNotificationSidebar}
          notificationCount={notificationCount}
        />
      )}
    </>
  );
};

export default DashboardHeader;
